import { iterateAiBlocks } from './ai-blocks.js';

// Other token grammars cannot contain opening braces. Scan them only between
// AI spans so a nested variable inside an AI hint stays part of that hint.
const OTHER_TOKEN_RE = /\{\{\s*ai2\s*:\s*([\w-]+)\s*\}\}|\{\{\s*([\w.]+)\s*\}\}/g;

/** @returns {Array<{kind: 'text', text: string} | {kind: 'variable', token: string} | {kind: 'ai', prompt: string} | {kind: 'ai2', id: string}>} */
export function parseMessageParts(text) {
    const out = [];
    const appendOtherParts = (segment) => {
        let last = 0;
        for (const match of segment.matchAll(OTHER_TOKEN_RE)) {
            if (match.index > last) out.push({ kind: 'text', text: segment.slice(last, match.index) });
            if (match[1]) out.push({ kind: 'ai2', id: match[1] });
            else out.push({ kind: 'variable', token: match[2] });
            last = match.index + match[0].length;
        }
        if (last < segment.length) out.push({ kind: 'text', text: segment.slice(last) });
    };
    let cursor = 0;
    for (const block of iterateAiBlocks(text)) {
        appendOtherParts(text.slice(cursor, block.start));
        out.push({ kind: 'ai', prompt: block.hint });
        cursor = block.end;
    }
    appendOtherParts(text.slice(cursor));
    return out;
}
